import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-158025cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-banner-bg" }
const _hoisted_2 = { class: "product-banner-text" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "lead mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseProductOverviewItemCard = _resolveComponent("BaseProductOverviewItemCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("product.newVersionTitle")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("product.newVersionSubtitle")), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_BaseProductOverviewItemCard, { vm: _ctx.vm }, null, 8, ["vm"])
    ])
  ]))
}